const HAS_SEEN_CREATE_VIDEO_INTRO_TILE_LOCAL_STORAGE_KEY = 'pmw_ai_chat_seen_create_video_intro_tile';

export const hasUserSeenAiChatCreateVideoIntroTile = async (): Promise<boolean> => {
  if (!window.PMW.isUserLoggedIn()) {
    return true;
  }

  if (getHasSeenCreateVideoIntroFromLocalStorage()) {
    return true;
  }

  try {
    const response = (await window.PMW.readLocal('ai/hasUserSeenAiChatCreateVideoIntroTile')) as {hasSeen: boolean};
    if (response.hasSeen) {
      setHasSeenCreateVideoIntroInLocalStorage();
    }
    return response.hasSeen;
  } catch (e) {
    console.error('Failed to check if user has seen AI chat create-video intro tile', e);
    return true;
  }
};

export const markAiChatCreateVideoIntroTileAsSeen = async (): Promise<void> => {
  setHasSeenCreateVideoIntroInLocalStorage();

  if (!window.PMW.isUserLoggedIn()) {
    return;
  }

  try {
    await window.PMW.writeLocal('ai/markAiChatCreateVideoIntroTileAsSeen');
  } catch (e) {
    console.error('Failed to mark AI chat create-video intro tile as seen', e);
  }
};

function getHasSeenCreateVideoIntroFromLocalStorage(): boolean {
  try {
    return localStorage.getItem(HAS_SEEN_CREATE_VIDEO_INTRO_TILE_LOCAL_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function setHasSeenCreateVideoIntroInLocalStorage(): void {
  try {
    localStorage.setItem(HAS_SEEN_CREATE_VIDEO_INTRO_TILE_LOCAL_STORAGE_KEY, '1');
  } catch {
    // ignore quota / private-browsing failures
  }
}
